import { Injector } from '@angular/core';
import { PackageType, PackageTypes } from '../package-type';
import { BillingType, BillingTypes } from '../billing-type';
import { AppTextService } from '@fi-shared/app-text';
import { BillingModuleTypes } from '@fi-shared/models/module-types';

export class CentralBillingUnitModuleModel {
    Id = 0;
    ModuleType = 0;
    ModuleTypeName = '';
    IsEnabled = true;
    IsEnabledText = '';
    BillingType = BillingType.Central;
    BillingTypeName = '';
    PackageType = PackageType.Free;
    PackageTypeName = '';
    BusinessUnitId = null;
    AllowSelectLevel = true;
    AllowLocalCharges = true;
    CanTurnModuleOff = true;

    protected appTextService: AppTextService;

    constructor(data, injector: Injector) {
        this.appTextService = injector.get(AppTextService);

        if (data) {
            this.Initialize(data);
        }
    }

    Initialize(data) {
        Object.assign(this, data);

        this.IsEnabledText = '-';
        if (this.CanTurnModuleOff) {
            if (this.IsEnabled) {
                this.IsEnabledText = this.appTextService.get('on');
            } else {
                this.IsEnabledText = this.appTextService.get('off');
            }
        }

        this.PackageTypeName = '-';
        if (this.AllowSelectLevel) {
            var packageTypeName = PackageTypes.find((item) => item.Id === data.PackageType);
            this.PackageTypeName = packageTypeName
                ? this.appTextService.get(packageTypeName.TextId)
                : 'Unknown package type';
        }

        const moduleTypeName = BillingModuleTypes.find((item) => item.Id === data.ModuleType);
        this.ModuleTypeName = moduleTypeName ? this.appTextService.get(moduleTypeName.TextId) : 'Unknown module type';

        const billingTypeName = BillingTypes.find((item) => item.Id === data.BillingType);
        this.BillingTypeName = billingTypeName
            ? this.appTextService.get(billingTypeName.TextId)
            : 'Unknown billing type';
    }
}
